<template>
  <div class="counting">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />
    <div class="counting__fecha">
      <div class="counting__employee" v-if="$route.name == 'countingPages'">
        <div class="counting__employee-title" @click="$router.push({ name: 'resumeMonthly' })">
          Empleados
        </div>
        <div class="counting__employee-names">{{ employeeName }}</div>
        <div class="counting__employee-actions" v-if="$store.getters.canWrite">
          <md-button @click="validar" class="md-raised md-dense md-primary"
            v-if="canValidate">Validar Mes</md-button
          >
          <md-button @click="recalcular" class="md-raised md-dense" v-if="canRecalculate">
            <md-progress-spinner v-if="isLoadingRecalc" :md-diameter="15" :md-stroke="2" md-mode="indeterminate">
            </md-progress-spinner>
            {{ isLoadingRecalc ? "Recalculando..." : "Recalcular" }}
          </md-button>
        </div>
      </div>
      
      <div class="counting__actions">
        <md-menu md-direction="bottom-start" md-align-trigger md-size="auto" v-if="$route.name == 'resumeMonthly'">
          <md-button class="md-primary md-raised" md-menu-trigger>Descargar</md-button>
          <md-menu-content>
            <md-menu-item>
              <md-button v-if="$route.name == 'resumeMonthly'" :href="url" :download="reporteName">Descargar Planilla
              </md-button>
            </md-menu-item>
            <md-menu-item>
              <md-button v-if="$route.name == 'resumeMonthly'" @click="downloadPdf"
                :disabled="isDownloadBoletaDisabled">Descargar Boletas</md-button>
            </md-menu-item>
            <md-menu-item>
              <md-button v-if="$route.name == 'resumeMonthly'" :href="urlGrati" :download="reporteNameGrati">Descargar
                Gratificaciones</md-button>
            </md-menu-item>
            <md-menu-item>
              <md-button v-if="$route.name == 'resumeMonthly'" @click="downloadAfp" :disabled="isDownloadAFPDisabled">
                Descargar AFP.net</md-button>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <v-date-picker v-if="$route.name == 'resumeMonthly'" :value="dateSelect" is-inline @update:fromPage="toMonth" class="only-month">
      </v-date-picker>
    </div>
    <div class="counting__main">
      <div class="counting__body">
        <router-view name="counting-view" :date="dateSelectISO" @checked-employees="checkEmployees"
          :downloadDone="dldone" @loading="loading = $event"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import dayjs from "dayjs";
export default {
  name: "Counting",
  created() {
    // this.$store.dispatch("summaryYear", this.$localStorage.get("businessID"));
    this.loading = true;
    this.$store.commit("SET_DATE_CALC", new Date());
    const d = new Date();
    this.$store
      .dispatch("summaryMonth", {
        id: this.$localStorage.get("businessID"),
        date: new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59).toISOString(),
      })
      .then((res) => {
        if (res.status == 200) {
          this.loading = false;
        }
      });
    this.getDayReports({
      date: new Date().toISOString(),
      businessID: this.$localStorage.get("businessID"),
    }).then((r) => {
      if (r.status == 200) {
        this.loading = false;
      }
    });
  },
  data() {
    return {
      //loading data
      loading: true,
      moveMonth: false,
      search: null,
      formats: {
        input: "WWWW',' DD 'de' MMMM 'de' YYYY",
      },
      userSelected: "",
      itemSelected: {},
      dateSelect: new Date(),
      employeeIds: [],
      dldone: false,
      isLoadingRecalc: false,
      isLoadingRecalcAll: false,
      monthLabel: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Setiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      isDownloadAFPDisabled: false,
    };
  },

  computed: {
    ...mapState({
      listEmploy: (state) => state.business.dailyReportList,
    }),
    ...mapGetters({
      // listEmploy: 'listEmploy'
      actualBusiness: "getDataBusiness",
    }),
    isDownloadBoletaDisabled() {
      return this.employeeIds.length === 0;
    },
    employeeName() {
      return this.$store.state.business.currentSummaryEmployee;
    },
    keyView() {
      if (!this.dateSelect) return -1;
      return this.dateSelect.month;
    },
    url() {
      return `https://nominas.blueboxperu.com/api/v1/business/${this.$store.state.business.businessId
        }/summaries/downloadxls?date=${new Date(this.dateSelect).toISOString()}`;
    },
    urlGrati() {
      return `https://nominas.blueboxperu.com/api/v1/business/${this.$store.state.business.businessId
        }/summaries/downloadgrati-xls?date=${new Date(this.dateSelect).toISOString()}`;
    },
    urlPlame5ta() {
      return `${process.env.VUE_APP_BASE_URL}business/${this.$store.state.business.businessId
        }/plame/download-5ta?date=${new Date(this.dateSelect).toISOString()}`;
    },
    urlPlameJor() {
      return `${process.env.VUE_APP_BASE_URL}business/${this.$store.state.business.businessId
        }/plame/download-jor?date=${new Date(this.dateSelect).toISOString()}`;
    },
    reporteName() {
      let month = this.monthLabel[new Date(this.dateSelect).getMonth()];
      let year = new Date(this.dateSelect).getFullYear();
      return `${this.actualBusiness.name}-${this.actualBusiness.ruc}-${month}-${year}.xls`;
    },
    reporteNameGrati() {
      let month = this.monthLabel[new Date(this.dateSelect).getMonth()];
      let year = new Date(this.dateSelect).getFullYear();
      return `${this.actualBusiness.name}-${this.actualBusiness.ruc}-${month}-${year} Gratificaciones.xls`;
    },
    dateSelectISO() {
      return new Date(this.dateSelect).toISOString();
    },
    canRecalculate(){
      if(!this.$store.state.business.summary.month) return false
      return this.$store.state.business.summary.month.validatedTo ? dayjs(this.$route.params.date).isAfter(this.$store.state.business.summary.month.validatedTo) : true
    },
    canValidate(){
      if(!this.$store.state.business.summary.month) return false
      console.log(this.$route.params.date, this.$store.state.business.summary.month.validatedTo);
      return this.$store.state.business.summary.month.validatedTo ? dayjs(this.$route.params.date).isAfter(this.$store.state.business.summary.month.validatedTo) : true
    }
  },

  filters: {
    formatDate(value) {
      let splitStr = value.split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        if (i == 0 || i == 3)
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
  },

  methods: {
    ...mapActions({
      // getEmployees: 'getEmployees',
      getDayReports: "getEmployeesDailyReport",
    }),

    displayEmpSheet(item) {
      this.itemSelected = item;
      this.userSelected = item.firstName.split(" ")[0] + " " + item.firstSurname;
    },

    setDay(val) {
      // console.log(val)
      this.loading = true;
      this.itemSelected = {};

      this.getDayReports({
        date: val.toISOString(),
        businessID: this.$localStorage.get("businessID"),
      }).then((r) => {
        if (r.status == 200) {
          this.loading = false;
        }
      });
    },

    toMonth(val) {
      if (val) {
        console.log(val);
        this.dateSelect = new Date(val.year, val.month, 0, 23, 59, 59);
        this.$store.commit("SET_DATE_CALC", new Date(this.dateSelect));
        console.log("to Month");
        this.loading = true;
        this.itemSelected = {};
        // var d = new Date();

        this.$store
          .dispatch("summaryMonth", {
            id: this.$localStorage.get("businessID"),
            date: new Date(this.dateSelect).toISOString(),
          })
          .then((res) => {
            if (res.status == 200) {
              this.loading = false;
            }
          });
      }
    },
    toYear() {
      this.$router.push({ name: "resumeYearly" });
    },
    validar() {
      this.$store
        .dispatch("validateMonth", {
          id: this.$route.params.id,
          date: this.$route.params.date,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$toasted.success("Cálculos verificados", {
              theme: "bubble",
              position: "top-right",
              duration: 1000,
              className: "short-message",
            });
          }
        })
        .catch((err) => {
          console.error(err.response);
          this.$toasted.show(`Error en consulta`, {
            theme: "bubble",
            position: "top-right",
            duration: 5000,
            className: "short-message",
          });
        });
    },
    recalcular() {
      if (!this.isLoadingRecalc) {
        this.isLoadingRecalc = true;
        this.$store
          .dispatch("clearEmployee", this.$route.params.id)
          .then((res) => {
            if (res.status == 200) {
              this.$store
                .dispatch("runEmployee", this.$route.params.id)
                .then(async (resp) => {
                  if (resp.status == 200) {
                    await this.$store.dispatch("summaryByMonth", {
                      id: this.$localStorage.get("businessID"),
                      employee: this.$route.params.id,
                      date: this.$route.params.date,
                    });
                    this.isLoadingRecalc = false;
                    this.$forceUpdate();
                  }
                });
            }
          })
          .catch((err) => {
            console.error(err.response);
            this.$toasted.show(`Error en consulta`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message",
            });
            this.isLoadingRecalc = false;
          });
      }
    },
    downloadExcel() {
      let id = this.$store.state.business.businessId;
      let date = new Date(this.dateSelect).toISOString();
      let url = `https://nominas.blueboxperu.com/api/v1/business/${id}/summaries/downloadxls?date=${date}`;
      var link = document.createElement("a");
      link.target = "_blank";
      link.href = url;
      link.download = "Reporte.xls";
      link.click();
    },
    downloadPdf() {
      if (this.employeeIds.length > 0) {
        this.loading = true;
        let id = this.$store.state.business.businessId;
        let date = new Date(this.dateSelect).toISOString();
        this.$store
          .dispatch("downloadPdf", {
            id: id,
            body: {
              employeeIds: this.employeeIds,
              date: date,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              this.dldone = true;
              window.location = res.data.url;
              // window.open(res.data.url, res.data.name)
              // console.log("descargando")
              this.loading = false;
              this.employeeIds = [];
              setTimeout(() => {
                this.dldone = false;
              }, 3000);
            }
            if (res.status >= 400) {
              this.$toasted.show(`Error en consulta`, {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message",
              });
            }
          });
      } else {
        this.$toasted.show(`Debe seleccionar a menos un empleado`, {
          theme: "bubble",
          position: "top-right",
          duration: 5000,
          className: "short-message",
        });
      }
      // let url = `https://nominas.blueboxperu.com/api/v1/business/${id}/summaries/downloadxls?date=${date}`;
      // var link = document.createElement("a");
      // link.target ="_blank"
      // link.href = url;
      // link.download = "Reporte.xls";
      // link.click();
    },
    downloadAfp() {
      this.isDownloadAFPDisabled = true;
      let id = this.$store.state.business.businessId;
      let date = new Date(this.dateSelect).toISOString();
      let url = `https://nominas.blueboxperu.com/api/v1/business/${id}/summaries/download-afpnet?date=${date}`;
      var link = document.createElement("a");
      link.target = "_blank";
      link.href = url;
      link.download = "Reporte.xls";
      link.click();
      this.isDownloadAFPDisabled = false;
    },
    checkEmployees($event) {
      this.employeeIds = $event;
    },
    resetDate() {
      console.log("reset date");
      // this.dateSelect = new Date();
    },
  },
};
</script>
<style lang="scss">
$b-blue: #000000;

.datepick {
  input[type="text"] {
    text-align: center;
    font-size: 16px;
    text-align: center !important;
    color: #4d4f5c;

    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
}

.only-month {
  background-color: #fff !important;
  border-radius: 6px;
  border: none !important;

  .c-weeks {
    display: none;
  }

  .c-weekdays {
    display: none;
  }
}

.only-year {
  background-color: #fff !important;
  border-radius: 6px;
  border: none !important;

  .c-months {
    display: none;
  }

  .c-weeks {
    display: none;
  }

  .c-weekdays {
    display: none;
  }
}

.md-menu-content {
  max-width: 405px;
}
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}

//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS

//datepicker
.datepick {
  // border-bottom: 1px solid #d7dae2;
  width: 21rem;
  border: medium none;
  border-radius: 6px;
  height: 4rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;

  @include mq("630px") {
    margin-left: 0.25rem;
    height: 3rem;
  }
}

#dateDay {
  width: 24rem;
  cursor: default;
  user-select: none;

  @include mq($lg) {
    cursor: pointer;
  }
}

//vue-material
.md-field {
  width: 18rem;
  margin: 0 2rem 1.5rem 24px;

  @include mq($sm) {
    width: 100% !important;
  }

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);

      &::after {
        color: $b-orange;
      }
    }

    &::after {
      background-color: #d7dae2;
    }

    &::before {
      background-color: $b-blue;
    }

    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }

      &::after {
        background-color: $b-orange;
      }

      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-field.md-theme-default>.md-icon::after {
  background-color: #fff;
}

.list-head {
  display: flex;
  // height: 3rem;
  // border: 1px solid #d7dae2;
  overflow: hidden;
  align-items: center;
  flex-wrap: wrap;
  width: 99rem;

  &>* {
    border: 1px solid #d7dae2;
    padding-left: 0.5rem;
    height: 3rem;
    line-height: 3rem;
  }

  .nombres {
    width: 9rem;
  }

  .sueldoxdias {
    width: 8rem;
  }

  .sueldomes {
    width: 9rem;
  }

  .asigfam {
    width: 6rem;
  }

  .vacaciones {
    width: 6rem;
  }

  .comisiones {
    width: 7rem;
  }

  .horasext {
    width: 7rem;
  }

  .bonos {
    width: 8rem;
  }

  .grati {
    width: 5rem;
  }

  .bono-grat {
    width: 6rem;
  }

  .cts {
    width: 4rem;
  }

  .dsctos {
    width: 7rem;
  }

  .netopagar {
    width: 7rem;
  }

  .essalud {
    width: 5rem;
  }

  .eps {
    width: 4rem;
  }
}

.counting {
  width: 100%;
  background-color: #eceff8;

  @include mq($md) {
    min-height: 100%;
  }

  &__fecha {
    // height: 9rem;
    border-bottom: 1px solid rgba($b-blue, 0.14);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    flex-direction: column;
    color: white;

    @include mq("630px") {
      // height: 5rem;
      flex-direction: row-reverse;
      justify-content: flex-end;
    }

    @include mq($md) {
      justify-content: center;
      padding: 0;
    }

    @include mq("945px") {
      justify-content: flex-end;
      padding: 1rem;
    }
  }

  &__employee {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;

    @include mq("630px") {
      margin: 0 0 0 1.5rem;
    }

    &-title {
      background-color: $b-blue;
      height: 3rem;
      line-height: 3rem;
      padding: 0 1.5rem;
      clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
      z-index: 30;

      @include mq($lg) {
        cursor: pointer;
      }
    }

    &-names {
      height: 3rem;
      // width: 3rem;
      line-height: 3rem;
      padding: 0 1.5rem 0 2rem;
      background-color: $b-emph;
      clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
      margin-left: -1.5rem;
      min-width: 6rem;
    }

    &-actions {
      margin: 0 1em;
    }
  }

  &__action {
    margin: 0 1rem;
  }

  &__main {
    padding: 1rem;
    // min-height: 30rem;
    position: relative;
  }

  &__search {
    display: flex;
    justify-content: center;
    width: 21rem;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    align-items: center;
    margin-top: 1rem;
    border-radius: 6px;
    height: 4rem;

    @include mq("630px") {
      margin-left: 0.25rem;
      margin-right: 0;
      width: 42.5rem;
    }

    @include mq($md) {
      width: 21rem;
      margin-left: auto;
      margin-right: auto;
    }

    @include mq("945px") {
      margin-left: 0.25rem;
      margin-right: 0;
      width: 42.5rem;
    }
  }

  &__body {
    // display: flex;
    // flex-wrap: wrap;
    // flex-direction: column;
    // margin-top: 1rem;
    // // height: 30rem;
    // // position: relative;
    // align-items: center;

    // &>*{
    //   margin: .25rem 0;
    //   @include mq($sm){
    //     margin: .25rem;
    //   }
    // }

    // @include mq('630px'){
    //   flex-direction: row;
    // }
    // @include mq($md){
    //   flex-direction: column;
    // }
    // @include mq('945px'){
    //   flex-direction: row;
    // }

    // overflow-x: scroll;
    margin-top: 1rem;
  }
}

.items-loading {
  width: 21rem;
  height: 4rem;
  background-color: white;
  border-radius: 9px;
}

.md-menu {
  margin: 6px 8px;
}

.md-list-item-content>.md-button {
  margin: 0;
}
</style>
